module.exports = __webpack_public_path__ + "img/g7.b3026a61.jpg";